import React, { useEffect, useState } from 'react'
import Nav from '../components/nav/Nav';
import SeachResultContainer from '../containers/SearchResult';
import { useParams } from 'react-router-dom';

const SearchResult: React.FC= () => {
  const { search } = useParams();
  useEffect(()=>{
    document.title = 'Elite Community CU | Search Results'
  }, [])


  return (
    <div>
      <Nav />
      <SeachResultContainer searchTerm={search}/>
    </div>
  )
}

export default SearchResult